import { render, staticRenderFns } from "./stu.vue?vue&type=template&id=c4a22b04&scoped=true"
import script from "./stu.vue?vue&type=script&lang=js"
export * from "./stu.vue?vue&type=script&lang=js"
import style0 from "./stu.vue?vue&type=style&index=0&id=c4a22b04&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a22b04",
  null
  
)

export default component.exports